// extracted by mini-css-extract-plugin
export default {"link":"AnimatedLink_link__q0Eui","container":"AnimatedLink_container__HDK9K","line":"AnimatedLink_line__90Kgd"};